import ComponentWrapper from 'helpers/SitecoreWrappers/ComponentWrapper/ComponentWrapper';
// import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import SearchHeaderWidget from 'helpers/Coveo/SearchHeaderWidget';
import ButtonGroup, { ButtonGroupProps } from 'helpers/SitecoreWrappers/ButtonGroup/ButtonGroup';
import { Search } from '.generated/Feature.CW.model';
import React, { JSX, useEffect, useState } from 'react';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import useDictionary from 'lib/hooks/useDictionary';
import classNames from 'classnames';
import { useSiteSettings } from 'lib/utils/page-data-static-props/pageDataContext';

export type SearchforDoctorsNearYouProps = Search.SearchForDoctorsNearYou &
  ButtonGroupProps & {
    params: {
      Theme: string;
    };
    templateId: string;
  };

const SearchforDoctorsNearYou = (props: SearchforDoctorsNearYouProps): JSX.Element => {
  const fields = props?.fields;
  const { getDictionaryValue } = useDictionary();
  const siteSettings = useSiteSettings()?.fields;
  const searchFields = ['cwfirstname', 'cwlastname', 'cwdegreetitles', 'cwspecialties'];
  const [coveoConfig, setCoveoConfig] = useState({
    searchHub: '',
    pipeline: '',
    accessToken: '',
    organizationId: '',
  });
  useEffect(() => {
    setCoveoConfig({
      searchHub: siteSettings?.providerSearchHub?.value || '',
      pipeline: siteSettings?.providerPipeline?.value || '',
      accessToken: siteSettings?.providerAccessToken?.value || '',
      organizationId: process.env.NEXT_PUBLIC_COVEO_ORG_ID || '',
    });
  }, [siteSettings]);

  const SearchLableText = getDictionaryValue('SearchButtonLabel');
  const widgetData = {
    locationSearchPlaceholderText: fields?.locationSearchPlaceholderText,
    searchButtonLabel: SearchLableText,
    searchTermPlaceholderText: fields?.searchTermPlaceholderText,
    searchLink: fields?.searchButtonLabel,
    searchConfig: coveoConfig!,
    shouldRedirect: true,
    searchFields: searchFields,
  };

  if (!coveoConfig?.searchHub || !coveoConfig?.accessToken || !coveoConfig?.pipeline) {
    return <></>;
  }

  return (
    <>
      <ComponentWrapper className="bg-white">
        <div className="max-w-screen-xxl mx-auto lg:px-[180px] px-10">
          <div className="lg:flex justify-between items-center">
            <h2 className="lg:text-36 lg:leading-43 text-[30px] leading-[36px] font-bold text-gray-900 font-centuryGothic">
              <PlainTextWrapper field={fields?.subHeading} />
            </h2>
            {/* <LinkWrapper
            field={{ value: { href: '/', text: 'Find Location' } }}
            ctaVariant="tertiary"
            ctaIcon="arrow-right"
            className="text-left w-fit"
          /> */}
          </div>
          {/* Search Bar */}
          <SearchHeaderWidget clearOnLoad {...widgetData} hasCoveoWrapper={false} />

          <div>
            <ButtonGroup
              {...props}
              WrapperClasses={classNames('lg:flex-row flex-col lg:gap-12 gap-6 flex-wrap mt-16')}
              ButtonWrapperClasses="lg:!gap-12 !gap-6"
            />
          </div>
        </div>
      </ComponentWrapper>
    </>
  );
};

export default SearchforDoctorsNearYou;
